import { Modal, HStack, VStack, Icon, Button, Text, Box } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import styles from "./Message.module.scss";
import { useIsMobile } from "@repo/utils";
import { useTranslation } from "react-i18next";

type MessageModalProps = {
  title?: string;
  subtitle?: string;
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
  onClose: () => void;
  secondarySubtitle?: string;
  buttonText?: string;
  onCross?: () => void;
};

export default function Message({
  title,
  subtitle,
  isModalOpen,
  setIsModalOpen,
  onClose,
  onCross,
  secondarySubtitle,
  buttonText,
}: MessageModalProps) {
  const { theme } = useTheme();
  const isMobile = useIsMobile();

  const isNarrowLayout = isMobile;

  const { t } = useTranslation("scaLogin");

  const header = (
    <HStack className={styles.header}>
      <Button
        variant="ghost"
        onPress={onCross ? onCross : () => setIsModalOpen(false)}
      >
        <Icon name="close" color={theme.colors.primary[40]} size={20} />
      </Button>
    </HStack>
  );

  const body = (
    <VStack className={styles.body}>
      <Icon
        name="errorOutlineMaroon"
        color={theme.colors.error[50]}
        size={50}
      />
      <VStack>
        <Text className={styles.title}>{title ?? t("message.title")}</Text>
        <Text className={styles.subTitle}>
          {subtitle || t("message.subtitle")}
        </Text>
        {secondarySubtitle && (
          <Text className={styles.secondarySubTitle}>
            {secondarySubtitle || t("message.thisNumberAlready")}
          </Text>
        )}
      </VStack>

      <Box width="100%" className={styles.btnContainer}>
        {!isNarrowLayout && (
          <Button className={styles.cancelBtn} onPress={onClose}>
            <Text className={styles.cancelBtnText}>{t("cancel")}</Text>
          </Button>
        )}
        <Button
          className={isNarrowLayout ? styles.supportBtn : styles.supportBtnWeb}
          style={{}}
          onPress={() => onClose()}
        >
          <Text className={styles.supportBtnText}>
            {buttonText ?? t("message.button")}
          </Text>
        </Button>
      </Box>
    </VStack>
  );

  return (
    <Modal
      isModalOpen={isModalOpen}
      onClose={onClose}
      width={isNarrowLayout ? "100%" : "31rem"}
      height="auto"
      customHeader={header}
      showFooter={false}
      body={body}
      overLayColor={theme.colors.overlay}
      styles={{
        modal: {
          borderTopLeftRadius: isMobile ? "2.5rem" : "1.5rem",
          borderTopRightRadius: isMobile ? "2.5rem" : "1.5rem",
          borderBottomLeftRadius: isMobile ? "0px" : "1.5rem",
          borderBottomRightRadius: isMobile ? "0px" : "1.5rem",
        },
      }}
    />
  );
}
